// Shared profile shape constants and SVG renderer for supply teacher mode

export const PROFILE_SHAPES = [
    { name: 'circle',   color: '#75B9BE', bg: '#F0FDFA' },
    { name: 'square',   color: '#F28482', bg: '#FFF5F5' },
    { name: 'triangle', color: '#8B5CF6', bg: '#F5F3FF' },
    { name: 'diamond',  color: '#F59E0B', bg: '#FFFBEB' },
    { name: 'star',     color: '#10B981', bg: '#ECFDF5' },
    { name: 'hexagon',  color: '#F97316', bg: '#FFF7ED' },
];

export const ShapeSVG = ({ name, color, size = 36 }) => {
    const s = size;
    switch (name) {
        case 'circle':
            return <svg width={s} height={s} viewBox="0 0 100 100"><circle cx="50" cy="50" r="46" fill={color} /></svg>;
        case 'square':
            return <svg width={s} height={s} viewBox="0 0 100 100"><rect x="8" y="8" width="84" height="84" rx="10" fill={color} /></svg>;
        case 'triangle':
            return <svg width={s} height={s} viewBox="0 0 100 100"><polygon points="50,6 96,92 4,92" fill={color} /></svg>;
        case 'diamond':
            return <svg width={s} height={s} viewBox="0 0 100 100"><polygon points="50,4 96,50 50,96 4,50" fill={color} /></svg>;
        case 'star':
            return <svg width={s} height={s} viewBox="0 0 100 100"><polygon points="50,4 61,36 95,36 68,57 79,92 50,70 21,92 32,57 5,36 39,36" fill={color} /></svg>;
        case 'hexagon':
            return <svg width={s} height={s} viewBox="0 0 100 100"><polygon points="50,4 93,27 93,73 50,96 7,73 7,27" fill={color} /></svg>;
        default:
            return <svg width={s} height={s} viewBox="0 0 100 100"><circle cx="50" cy="50" r="46" fill={color} /></svg>;
    }
};
